import {useParams} from "react-router-dom"
import {Fragment, useEffect, useState} from "react"
import {fieldToNames} from "./Teams"
import {fetchWithAuth, getCSRFToken} from "../auth";

export const TeamHistoryDetail = () => {
    const {id, id2} = useParams()

    const [history, setHistory] = useState(
        {
            'current': [],
            'last': {}
        }
    )
    const teamId = id
    const historyId = id2

    async function getHistory() {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `teams/${teamId}/history/${historyId}/`, {
            headers: {'X-CSRFToken': getCSRFToken()},
            credentials: 'include'
        })
        const respJson = await resp.json()
        const current = respJson.current
        const last = respJson.last
        const currentList = Object.keys(current).sort().map((key) => [key, current[key]]);
        setHistory(
            {
                current: currentList,
                last: last
            }
        )
    }

    useEffect(() => {
        getHistory()
    }, [])


    const getMemberChanges = (oldMemberList, newMemberList) => {

        const combinedMemberList = [...new Set([...oldMemberList, ...newMemberList])]
        const addedMembers = newMemberList.filter(item => !oldMemberList.includes(item))
        const removedMembers = oldMemberList.filter(item => !newMemberList.includes(item))

        return (
            <div>
                {combinedMemberList.map((item) => (
                    <div>
                        {addedMembers.includes(item) ? (
                            <div>
                                <span style={{color: "green"}}>{item}</span>
                            </div>
                        ) : removedMembers.includes(item) ? (
                            <div>
                              <span style={{
                                  marginRight: "0.5rem",
                                  color: "red",
                                  textDecoration: "line-through",
                                  textDecorationColor: "rgba(255,0,0,0.4)"
                              }}>{item}</span>
                            </div>
                        ) : (
                            <div>{item}</div>
                        )}
                    </div>
                ))}
            </div>
        );
    }


    const renderMismatch = (item, oldVal, newVal) => {

        if (item[0] === "members") {
            return getMemberChanges(oldVal, newVal)
        } else {
            return (
                <div>
                    <span style={{
                        marginRight: "0.5rem",
                        color: "red",
                        textDecoration: "line-through",
                        textDecorationColor: "rgba(255,0,0,0.4)"
                    }}>{oldVal}</span>
                    <span style={{color: "green"}}>{newVal}</span>
                </div>
            )
        }
    }

    return (
        <div style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            display: "flex"
        }}>
            <div style={
                {
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                    padding: "1rem",
                    flexWrap: "wrap"
                }}>
                {history.current.map((item) => {
                    if ((!item[1] && !history.last[item[0]]) || !fieldToNames[item[0]]) {
                        return <Fragment key={item[0] + "0"}></Fragment>
                    }
                    let oldVal = history.last[item[0]]
                    const newVal = item[1] == null ? 'none' : item[1]
                    const mismatch = oldVal !== newVal

                    oldVal = oldVal === null ? 'none' : oldVal

                    return <div key={item[0]} style={{
                        minWidth: "7rem",
                        padding: "0.7rem",
                        border: mismatch ? "1px solid white" : "1px solid var(--tds-light-blue)",
                        backgroundColor: mismatch ? "var(--tds-light-blue)" : ""
                    }}>
                        <div style={{fontWeight: "bold"}}>{fieldToNames[item[0]]}</div>
                        {mismatch ? (
                            renderMismatch(item, oldVal, newVal)
                        ) : (
                            <div>{newVal}</div>
                        )}
                    </div>
                })}
            </div>
        </div>
    )

}
